import React from 'react';

import ROUTES from '../../../routes';
import { ContentContainer } from '../contentComponents';
import { SectionContainer, SectionHeading } from '../sectionComponents';
import StandardFlex from '../StandardFlex';

import CaseStudyCard from '@components/CaseStudyCard';

const images1 = [
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/widgets/conversion-rate-1.svg`,
    alt: 'screenshot-conversion-rate',
    style: {
      boxShadow: 'var(--bs-header)',
      border: '1px solid #f4f4f4',
      borderRadius: '12px',
      width: '100%',
    },
  },
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/widgets/monthly-signups.svg`,
    alt: 'screenshot-monthly-signups',
    style: {
      boxShadow: 'var(--bs-header)',
      border: '1px solid #f4f4f4',
      borderRadius: '12px',
      width: '100%',
    },
  },
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/widgets/conversion-rate-2.svg`,
    alt: 'screenshot-conversion-rate',
    style: {
      boxShadow: 'var(--bs-header)',
      border: '1px solid #f4f4f4',
      borderRadius: '12px',
      width: '100%',
    },
  },
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/widgets/user-retention.svg`,
    alt: 'screenshot-user-retention',
    style: {
      boxShadow: 'var(--bs-header)',
      border: '1px solid #f4f4f4',
      borderRadius: '12px',
      width: '100%',
    },
  },
];

const imagesSharing = [
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/features/sharing.svg`,
    alt: 'popsql app screenshot',
  },
];

const imagesSlack = [
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/features/slack.svg`,
    alt: 'popsql app screenshot',
  },
];

const SecondSection = ({ heading }) => {
  return (
    <SectionContainer isGrey>
      <SectionHeading text={heading || 'Easily share insights'} />
      {/* <SectionSubheading text="Give your team easy access to queries, dashboards and results." /> */}
      <ContentContainer className="flex">
        <StandardFlex
          heading="Share query links"
          subheading="Share a URL for your query rather than copying and pasting SQL over chat."
          images={imagesSharing}
          link={{
            text: 'Learn more',
            href: '/shared-queries/',
            asPath: '/shared-queries/',
          }}
        />

        <div className="h-16 lg:h-16" />

        <StandardFlex
          heading="Create dashboards"
          subheading="Add queries and charts to a dashboard to see your key metrics."
          imagesContainerClassNames="grid grid-cols-2 gap-4"
          images={images1}
          link={{
            text: 'Learn more',
            href: '/product/dashboards/',
            asPath: '/product/dashboards/',
          }}
          isReverse
        />

        <div className="h-16 lg:h-24" />

        <StandardFlex
          heading="Integrates with Slack"
          subheading="Push your key metrics to Slack to keep your team up to date."
          imagesContainerClassNames="relative"
          images={imagesSlack}
          link={{
            text: 'Learn more',
            href: ROUTES.docsPost('slack').href,
            asPath: ROUTES.docsPost('slack').asPath,
          }}
          // quote={{
          //   author: "Ankit Gordhandas",
          //   role: "CEO / Co-Founder, Intersect Labs",
          //   logo: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/instersect-labs.svg`,
          //   logoHeight: 16,
          //   body:
          //     "\"The Aha moment for us was sharing queries with our customers. No more emailing CSVs of data or wasting time re-running the same query\"."
          // }}
        />
        <CaseStudyCard />
      </ContentContainer>
    </SectionContainer>
  );
};
export default SecondSection;
